<template>
    <div class="carousel">
        <div class="carousel-grid" :data-movie-id="movieid">
            <movie-list v-for="(movie, key) in movies" :movie="movie" :key="movie.id" :index="key"></movie-list>
        </div>
    </div>
</template>


<script>
    import MovieTeaserDefault from './MovieTeaserDefault.vue';
    import {EventBus} from '../lib/EventBus';
    import Vue from 'vue';

    export default {

        components: {
            movieList: MovieTeaserDefault
        },

        props: ['movieid'],

        data() {
            return {
                movies : [],
            }
        },

        watch: {
            movieid : function(val, oldVal) {
                this.movies = this.getMovies();
            }
        },

        mounted () {
            this.movies = this.getMovies();
            EventBus.$on('receive-movies', movies => {
                this.movies = this.getMovies();
            });
        },

        methods: {
            getMovies() {
                let movies = window.fetchMovies();
                if (movies.length > 0) {
                    let currentMovie = this.movieid;
                    movies = _.filter(movies, function(o) { return o.id !== currentMovie });
                    let sortedMoviesByTimestamp = _.shuffle(movies);
                    movies = _.take(sortedMoviesByTimestamp, 8);
                }
                return movies;
            }
        },
    }
</script>




// WEBPACK FOOTER //
// MostViewedMoviesList.vue?02acccb8